import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'da-small-image-box',
    templateUrl: './small-image-box.component.html',
    styleUrls: ['./small-image-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SmallImageBox {
    @Input() data;

    constructor() {}
}
